var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.312,2l3.198.455c18.834,4.055,24.027,28.805,7.782,39.783-7.146,4.829-16.222,4.919-23.651.671l-10.625,3.091v-.172l3.093-10.522c-1.175-2.151-2.131-4.407-2.637-6.82l-.455-3.197c.037-.852-.05-1.728,0-2.578C2.658,11.739,11.761,2.641,22.733,2h2.579ZM15.404,9.841c-1.253.206-2.552,2.41-2.789,3.571-1.753,8.585,7.362,18.394,14.888,21.16,2.527.929,6.948,1.635,9.198-.175,1.007-.811,2.09-1.89,1.078-3.137-1.202-1.482-3.036-2.823-4.303-4.292-1.446-.76-1.975.499-2.879,1.24-1.302,1.068-2.741,1.098-4.04.005-2.369-1.993-4.548-4.706-6.876-6.79-.916-1.026-1.003-2.449-.249-3.602.71-1.085,2.513-1.825,1.456-3.362-1.462-1.22-2.793-3.097-4.257-4.252-.406-.32-.689-.454-1.227-.365Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.cbc6f14c5e5cd29749e573df84f152ba.svg";
export { ForwardRef as ReactComponent };